import { FC } from 'react'
import {
  Show,
  SimpleShowLayout,
  TextField,
  useRecordContext,
  TopToolbar,
  EditButton,
  DeleteButton,
} from 'react-admin'
import { GemeenteResponse } from '../../types/apiRequests'

const ShowActions = () => (
  <TopToolbar>
    <EditButton />
    <DeleteButton />
  </TopToolbar>
)

const GemeentenShowContent: FC = () => {
  const record = useRecordContext<GemeenteResponse>()
  if (!record) return null

  return (
    <SimpleShowLayout>
      <TextField source="naam" label="Naam" />
      <TextField source="gm_code" label="Gemeentecode" />
      <TextField source="gm_naam" label="Gemeentenaam" />
      <TextField source="provincie" label="Provincie" />
      <TextField source="corop" label="COROP-regio" />
    </SimpleShowLayout>
  )
}

const GemeentenShow: FC = () => (
  <Show actions={<ShowActions />}>
    <GemeentenShowContent />
  </Show>
)

export default GemeentenShow
